export default __webpack_public_path__ + "static/services4-082ea5176939f91af1559eca17874001.png";